export const ROLE_ADMIN = 1;
export const ROLE_PUBLISHER = 2;
export const ROLE_CREATOR = 3;
export const ROLE_GUEST = 4;
const ROLE_ADMIN_TITLE = 'admin';
const ROLE_PUBLISHER_TITLE = 'publisher';
const ROLE_CREATOR_TITLE = 'creator';
const ROLE_GUEST_TITLE = 'guest';

export const roles = {
  [ROLE_ADMIN]: ROLE_ADMIN_TITLE,
  [ROLE_PUBLISHER]: ROLE_PUBLISHER_TITLE,
  [ROLE_CREATOR]: ROLE_CREATOR_TITLE,
  [ROLE_GUEST]: ROLE_GUEST_TITLE
};
export const cloudRoles = {
  [ROLE_ADMIN]: ROLE_ADMIN_TITLE,
  [ROLE_PUBLISHER]: ROLE_PUBLISHER_TITLE,
  [ROLE_CREATOR]: ROLE_CREATOR_TITLE
};
export const rolesDescription = {
  [ROLE_ADMIN]: 'accounts.roles.admin_description',
  [ROLE_PUBLISHER]: 'accounts.roles.publisher_description',
  [ROLE_CREATOR]: 'accounts.roles.creator_description',
  [ROLE_GUEST]: 'accounts.roles.guest_description'
};
const CAN_ACCESS_CALANDAR = 'can_access_exchange_portal_calendar';
const CAN_ACCESS_ANALYTICS = 'can_access_exchange_portal_analytics';
const CAN_ACCESS_MEDIA_UPLOAD = 'can_access_exchange_portal_media_upload';
const CAN_ACCESS_APPROVAL_ = 'can_access_exchange_portal_approval';
const CAN_ACCESS_CALANDAR_DRAFTS = 'can_access_exchange_portal_calendar_drafts';
const CAN_ACCESS_CALENDAR_NOTES = 'can_access_calendar_notes';

const CAN_ACCESS_COMMUNICATION = 'permissions_access_communication';
export const GUEST_USER_PERMISSIONS_LIST = [
  CAN_ACCESS_CALANDAR,
  CAN_ACCESS_ANALYTICS,
  CAN_ACCESS_MEDIA_UPLOAD,
  CAN_ACCESS_APPROVAL_,
  CAN_ACCESS_CALANDAR_DRAFTS,
  CAN_ACCESS_CALENDAR_NOTES
];

const APPROVAL_PERMISSION = 'lomavis_exchange_permission_approval';
const CALANDER_PERMISSION = 'lomavis_exchange_permission_calendar';
const CALANDER_DRAFTS_PERMISSION =
  'lomavis_exchange_permission_calendar_access_drafts';
const ANALYTICS_PERMISSION = 'lomavis_exchange_permission_analytics';
const MEDIA_UPLOAD_PERMISSION = 'lomavis_exchange_permission_upload_media';
const CALENDAR_NOTES_PERMISSION = 'lomavis_calendar_permission_notes';

export const GUEST_USER_PERMISSIONS_KEYS = [
  APPROVAL_PERMISSION,
  CALANDER_PERMISSION,
  CALANDER_DRAFTS_PERMISSION,
  ANALYTICS_PERMISSION,
  MEDIA_UPLOAD_PERMISSION,
  CALENDAR_NOTES_PERMISSION
];
export const GUEST_USER_PERMISSIONS = {
  [CAN_ACCESS_CALANDAR]: {
    name: 'calendar',
    description: 'accounts.permissions.can_access_exchange_portal_calendar',
    key: CALANDER_PERMISSION
  },
  [CAN_ACCESS_CALANDAR_DRAFTS]: {
    name: 'calendar_drafts',
    description:
      'accounts.permissions.can_access_exchange_portal_calendar_drafts',
    key: CALANDER_DRAFTS_PERMISSION
  },
  [CAN_ACCESS_ANALYTICS]: {
    name: 'analytics',
    description: 'accounts.permissions.can_access_exchange_portal_analytics',
    key: ANALYTICS_PERMISSION
  },
  [CAN_ACCESS_MEDIA_UPLOAD]: {
    name: 'media_upload',
    description: 'accounts.permissions.can_access_exchange_portal_media_upload',
    key: MEDIA_UPLOAD_PERMISSION
  },
  [CAN_ACCESS_APPROVAL_]: {
    name: 'approval',
    description: 'accounts.permissions.can_access_exchange_portal_approval',
    key: APPROVAL_PERMISSION
  },
  [CAN_ACCESS_CALENDAR_NOTES]: {
    name: 'calendar_notes',
    description: 'accounts.permissions.can_access_calendar_notes',
    key: CALENDAR_NOTES_PERMISSION
  }
};

export const ACCESS_TYPE_ALL = 1;
export const ACCESS_TYPE_SELECTED = 2;
export const ACCESS_TYPES = {
  [ACCESS_TYPE_SELECTED]: 'selected',
  [ACCESS_TYPE_ALL]: 'all'
};

export const ALL_USERS_PERMISSIONS = {
  [CAN_ACCESS_COMMUNICATION]: {
    name: 'communication',
    description: 'accounts.permissions.can_access_communication',
    key: CAN_ACCESS_COMMUNICATION
  }
};

export const ALL_USERS_PERMISSIONS_KEYS = [CAN_ACCESS_COMMUNICATION];
